import { Box, Container, Stack } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router';
import logoSource from '../../assets/sustain_logo.png';
import { useTypedSelector } from '../../reducers';
import { useIsAuthenticated } from '../../hooks';
import SetPasswordForm from './SetPasswordForm';
import React from 'react';

export default function SetPasswordScreen() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { viewMode } = useTypedSelector((state) => state.auth);

  const email = searchParams.get('email') || '';
  const token = searchParams.get('token') || '';

  const isAuthenticated = useIsAuthenticated();

  React.useEffect(() => {
    if (isAuthenticated) {
      navigate(viewMode === 'admin' ? '/library' : '/users');
    }
  }, [isAuthenticated, navigate, viewMode]);

  if (!email || !token) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100vh"
      >
        <Container>
          <Stack alignItems="center" spacing={5}>
            <img src={logoSource} alt="logo" width={212} height={67} />
            <Box width="100%" maxWidth={552}>
              <p>
                Invalid set password link. Please check your email for the
                correct link.
              </p>
            </Box>
          </Stack>
        </Container>
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
    >
      <Container>
        <Stack alignItems="center" spacing={5}>
          <img src={logoSource} alt="logo" width={212} height={67} />
          <Box width="100%" maxWidth={552}>
            <SetPasswordForm email={email} token={token} />
          </Box>
        </Stack>
      </Container>
    </Box>
  );
}
